import React, { createContext, useContext, useState } from "react";

const UploadContext = createContext();

export const useUpload = () => useContext(UploadContext);

export const UploadProvider = ({ children }) => {
  const [uploadState, setUploadState] = useState({
    isUploading: false,
    estimatedTime: null,
    message: null,
  });

  const startUpload = (estimatedTime, message = null) => {
    setUploadState({
      isUploading: true,
      estimatedTime,
      message,
    });
  };

  const finishUpload = () => {
    setUploadState({
      isUploading: false,
      estimatedTime: null,
      message: null,
    });
  };

  return (
    <UploadContext.Provider
      value={{
        uploadState,
        startUpload,
        finishUpload,
      }}
    >
      {children}
    </UploadContext.Provider>
  );
};
